import { render, staticRenderFns } from "./DormForm.vue?vue&type=template&id=2b5cde30&"
import script from "./DormForm.vue?vue&type=script&lang=js&"
export * from "./DormForm.vue?vue&type=script&lang=js&"
import style0 from "./DormForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DormForm.vue"
export default component.exports